import { render, staticRenderFns } from "./MealsFilterHotel.vue?vue&type=template&id=31156211&scoped=true"
import script from "./MealsFilterHotel.vue?vue&type=script&lang=ts"
export * from "./MealsFilterHotel.vue?vue&type=script&lang=ts"
import style0 from "./MealsFilterHotel.vue?vue&type=style&index=0&id=31156211&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31156211",
  null
  
)

export default component.exports